import { Segment } from "../../types/flights";
import enquiryscss from "../../../sass/enquiry-list/Enquiry.module.scss";

export const EDFlightSegment: React.FC<{
  segments: Segment[] | undefined;
}> = (props) => {
  return (
    <>
      {props.segments && props.segments.length ? (
        <div className={enquiryscss.segmentContainer}>
          <h6 className={enquiryscss.enquiryDetailHeading}>
            {" "}
            Segment Details:{" "}
          </h6>
          {props.segments?.map((seg, index) => {
            return (
              <div
                key={`segment-${index}`}
                className={`${enquiryscss.sCrmSegmentItem} shadow-sm`}
              >
                <div className="row align-items-center">
                  <div className="col-lg-2">
                    <div className={`${enquiryscss.segment} segment-${index}`}>
                      Segment
                      <span className={enquiryscss.bgSegmentNo}>
                        {" "}
                        {index + 1}
                      </span>
                    </div>
                  </div>
                  <div className="col-lg-4 d-flex align-items-end">
                    <div className={enquiryscss.segmentSubItem}>
                      Origin: <br /> <span> {seg.origin} </span>
                    </div>
                    <div className={enquiryscss.flightIcon}>
                      <i className="fas fa-plane"></i>
                    </div>
                    <div className={enquiryscss.segmentSubItem}>
                      Destination: <br /> <span>{seg.destination}</span>
                    </div>
                  </div>
                  {seg.flightNumber && (
                    <div className="col-lg-2 col-md-4 col-5">
                      <div className={enquiryscss.segmentSubItem}>
                        Flight No: <br /> <span>{seg.flightNumber} </span>
                      </div>
                    </div>
                  )}
                  <div className="col-lg-2 col-7">
                    <div className={enquiryscss.segmentSubItem}>
                      Departure Date:{" "}
                      {seg.isFlexible && (
                        <span
                          className={`${enquiryscss.flexible} badge border rounded-pill`}
                        >
                          flexible
                        </span>
                      )}
                      <br /> <span> {seg.departureDate}</span>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      ) : null}
    </>
  );
};
